import debug from "debug";

export const authLog = debug("hangar:auth");
export const fetchLog = debug("hangar:fetch");
export const initialStateLog = debug("hangar:initialState");
export const routePermLog = debug("hangar:routePerm");
export const axiosLog = debug("hangar:axios");
export const settingsLog = debug("hangar:settings");
export const domainLog = debug("hangar:domain");
export const langLog = debug("hangar:lang");
export const kratosLog = debug("hangar:kratos");
export const prismLog = debug("hangar:prism");
export const backendDataLog = debug("hangar:backendData");
export const dataLoaderLog = debug("hangar:dataLoader");
